import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IReViewExamlistID } from "../../../Pages/Exam/IExam";

export const AddSubscriptionSlice = createSlice({
  name: "AddSubscriptionSlice",
  initialState: {} as IReduxState<IReViewExamlistID[]>,
  reducers: {
    AddSubscription: (state) => {
      state.isLoading = true;
    },
    successAddSubscription: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAddSubscription: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddSubscription: (state) => {
      state.data = {};
    },
  },
});

export const {
  AddSubscription,
  successAddSubscription,
  failureAddSubscription,
  clearAddSubscription,
} = AddSubscriptionSlice.actions;

export default AddSubscriptionSlice.reducer;
